import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "children", "disabled", "href", "onPress", "role", "style", "target", "testID"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo } from 'react';
import { prefixStyle } from '@lada/prefix';
import systemFontsDefaultLetterSpacing from '@bubble-ui/particle-system-fonts-default-letter-spacing';
export var Link = _ref => {
  var {
      ariaLabel,
      children,
      disabled,
      href,
      onPress,
      role,
      style,
      target,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      testID
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var mergedStyles = useMemo(() => {
    var restOfStyles = style || {};
    var letterSpacing = restOfStyles.letterSpacing ? restOfStyles.letterSpacing : systemFontsDefaultLetterSpacing(restOfStyles.fontSize);
    return prefixStyle(_objectSpread(_objectSpread(_objectSpread({}, restOfStyles), restOfStyles.lineHeight && {
      lineHeight: "".concat(restOfStyles.lineHeight, "px")
    }), {}, {
      letterSpacing: "".concat(letterSpacing, "px"),
      fontSmoothing: 'antialiased',
      textRendering: 'geometricPrecision',
      textSizeAdjust: 'none'
    }));
  }, [style]);
  return disabled ? /*#__PURE__*/React.createElement("span", _extends({
    "aria-disabled": "true",
    role: role || 'link'
  }, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}, {
    style: mergedStyles
  }, props), children) : /*#__PURE__*/React.createElement("a", _extends({
    tabIndex: 0,
    href: href,
    target: target
  }, role ? {
    role
  } : {}, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}, {
    style: mergedStyles,
    onClick: onPress
  }, props), children);
};
//# sourceMappingURL=Link.js.map